import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-f-company-mactrans',
    templateUrl: './f-company-mactrans.component.html',
    styleUrls: ['./f-company-mactrans.component.scss'],
    standalone: false
})
export class FCompanyMACTransComponent {
     customerType = CustomerType;
     powerInvalid:string = '';
     constructor(public generalService: GeneralService, public enrollmentService: EnrollmentService) {
          if(environment.NODE_ENV === ''){
               console.log(JSON.stringify(enrollmentService.newCustomer));
          }
      }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit() {
          setTimeout(() => this.scrollToTop(), 500);
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngAfterViewInit(){
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     testPowerNumber(){
          var pattern = /^[0-9]*$/;
          if (this.enrollmentService.newCustomer!.numberOfPowerUnits === null){
               this.powerInvalid ='required';
          } else if (this.enrollmentService.newCustomer!.numberOfPowerUnits! < 0) {
               this.powerInvalid = 'gthaneto'
          } else if (this.enrollmentService.newCustomer!.numberOfPowerUnits! > 1000000000) {
               this.powerInvalid ='lthaneto';
          } else if(this.enrollmentService.newCustomer!.numberOfPowerUnits && !pattern.test(this.enrollmentService.newCustomer!.numberOfPowerUnits!.toString())){
               this.powerInvalid ='notNumber';
          } else {
               this.powerInvalid ='';
          }
     }

     pageValid(){
          if(this.enrollmentService.newCustomer!.interIntraState === ''){
               return 'true'
          }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits === null || 
               this.enrollmentService.newCustomer!.numberOfPowerUnits === undefined){
               return 'true'
          }else if(this.enrollmentService.newCustomer!.numberOfPowerUnits! < 0 ||
               this.enrollmentService.newCustomer!.numberOfPowerUnits! > 1000000000 ){
               return 'true'
          }else if(this.powerInvalid !== ""){
               return 'true'
          }else{
               return null;
          }
     }
}
